import { Component, Input, OnInit } from '@angular/core';
import { MenuController, ModalController, NavController, NavParams } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { ChooseDoctorComponent } from '../choose-doctor/choose-doctor.component';
import { DoctorProfileDetailModalComponent } from '../doctor-profile-detail-modal/doctor-profile-detail-modal.component';
import * as firebase from 'firebase';
import { AngularFirestore } from '@angular/fire/firestore';
import { Profile, ProfileModel } from 'src/models/profile/profile';
import { AccountModel } from 'src/models/accounts/account';
import { ProfileUsersModel } from 'src/models/profile/profile-users/profile-users';
import { CrudService } from '../../admin/services/crud/crud.service';
import { AppointmentModel } from 'src/models/public-collective/appointment/appointment';
import { DoctorProfileTypeModalPage } from '../doctor-profile-type-modal/doctor-profile-type-modal.page';
import { LoaderService } from '../../expert/expert-appointments/core/loader.service';
import { OnlineConversation } from 'src/models/profile/online-conversation';
import { AngularFireAuth } from '@angular/fire/auth';
import { ConferenceStatus, ConferencType, ConnectionStatus, VideoConference } from 'src/models/video-conference';
import { TranslateService } from '@ngx-translate/core';
import { CheckoutIyzicoPage } from '../checkout-iyzico/checkout-iyzico.page';
import { ConversationService, ConvInfo } from 'src/app/services/conversation-service/conversation.service';

// connectToDoctor(item.path, item.accountId, item.id, item.account.name) bağlantı talebi
@Component({
  selector: 'app-choose-doctor-list-modal',
  templateUrl: './choose-doctor-list-modal.component.html',
  styleUrls: ['./choose-doctor-list-modal.component.scss'],
})
export class ChooseDoctorListModalComponent implements OnInit {
  conversationType: string;

  branchRef: string;
  // tslint:disable-next-line:max-line-length
  profiles = [] as { profile: ProfileModel, profileUser: ProfileUsersModel, account: AccountModel, accountId: string, ref: firebase.firestore.DocumentReference, id: string, rate: number, count: number, path: string }[];
  constructor(private modalController: ModalController,
              private menu: MenuController,
              private firestore: AngularFirestore,
              private crudService: CrudService<object, ProfileUsersModel>,
              private translate: TranslateService,
              private navCtrl: NavController,
              private navParams: NavParams,
              private ionLoader: LoaderService,
              private afAuth: AngularFireAuth,
              private convService: ConversationService
              ) { }

  ngOnInit() {
    this.conversationType = this.navParams.get('conversationType');
    this.branchRef = this.navParams.get('branchRef');
    this.expertList(this.branchRef);
  }
  dismiss() {
    this.modalController.dismiss();
  }

  showLoader() {
    this.ionLoader.presentLoading();
  }

  hideLoader() {
    this.ionLoader.dismiss();
  }


  expertList(branch: string) {
    this.showLoader();
    console.log(branch);

    const arr = branch.split('/'); // groups/id/branches/id
    const firestoreRef = this.firestore.collection(arr[0]).doc(arr[1]).collection(arr[2]).doc(arr[3]).ref; // branch firestore  ref
    const firestoreArr = [];
    // tslint:disable-next-line:max-line-length
    this.firestore.collectionGroup('expertBranches', ref => ref.where('branchId', '==', firestoreRef)).get().toPromise().then(res => { // all experts filter by branch
      if (res.docs.length > 0) {
        let spinnerLength = res.docs.length;
        let spinnerCounter = 0;
        res.docs.forEach((item) => {
          const accArr = item.ref.path.split('/');
          // accArr => 0: "accounts" 1: "accountId" 2: "profile" 3: "profileId" 4: "profileBranches" 5: "pBId" 6: "expertBranches" 7: "eBId"

          const resRefAcc = this.firestore.collection(accArr[0]).doc(accArr[1]).ref;
          resRefAcc.get().then(resAcc => {  // get account
            const accountExpert = resAcc.data() as AccountModel;
            if (accountExpert.confirmStatusByAdmin === true) {
              const resRef = this.firestore.collection(accArr[0]).doc(accArr[1]).collection(accArr[2]).doc(accArr[3]).ref; // profileRef
              resRef.get().then(resProfile => { // getProfile
                const profileData = resProfile.data() as ProfileModel;
                console.log(profileData);

                if (profileData && profileData.instantVideo === true) { // is profile video acception true
                  console.log(profileData);

                  // tslint:disable-next-line:max-line-length
                  this.crudService.findFirstRefPromise(accArr[0] + '/' + accArr[1] + '/' + accArr[2], accArr[3], 'profileUsers').then(resUser => { // profileWorker => expert
                    if (resUser !== null) {
                      console.log(resUser);
                      spinnerCounter++;
                      // tslint:disable-next-line:max-line-length
                      this.firestore.collection('appointments', ref => ref.where('profileId', '==', resRef).where('feedback.rate', '>', 1)).get().toPromise().then(async resRates => { // profile ait önceki görüşmelerin değerlendirme(yıldızlama) bilgisi her profilde olmayabilir ilk kez görüşüyor olabilir
                        if (resRates && resRates.docs && resRates.docs.length > 0) {
                          const count = resRates.docs.length;
                          let row = 0;
                          let sumRates = 0;
                          let avgRates = 0;

                          // tslint:disable-next-line:no-shadowed-variable
                          resRates.docs.forEach((item) => {
                            row = row + 1;
                            const data = item.data() as AppointmentModel;
                            sumRates = sumRates + data.feedback.rate;
                            console.log(item.data());
                            if (row === resRates.docs.length) {
                              avgRates = sumRates / row;
                              // tslint:disable-next-line:max-line-length
                              this.profiles.push({ profile: resProfile.data() as ProfileModel, profileUser: resUser.obj, account: resAcc.data() as AccountModel, accountId: resAcc.id, ref: resRef, id: resProfile.id, rate: avgRates, count, path: resRef.path });
                              console.log(this.profiles);

                            }

                          });
                        } else {
                          // tslint:disable-next-line:max-line-length
                          this.profiles.push({ profile: resProfile.data() as ProfileModel, profileUser: resUser.obj, account: resAcc.data() as AccountModel, accountId: resAcc.id, ref: resRef, id: resProfile.id, rate: 0, count: 0, path: resRef.path });
                          console.log(this.profiles);
                        }


                        await this.spinnerTime(spinnerLength, spinnerCounter).then(hideResult => {
                          if (hideResult === true) {
                            this.hideLoader();
                          }
                        });
                      }).catch(errRates => {
                        console.log(errRates);
                      });
                    } else {
                      spinnerLength = spinnerLength - 1;
                    }



                  }).catch(errUser => {
                    console.log(errUser);
                  });
                } else {
                  spinnerLength = spinnerLength - 1;
                }
              }).catch(errProfile => {
                console.log(errProfile);
              });
            } else {
              spinnerLength = spinnerLength - 1;
            }


          }).catch(errResAcc => {
            console.log(resRefAcc);
          });

        });
      } else {
        this.hideLoader();
      }
    }).catch(err => {
      console.log(err);
    });



  }

  async spinnerTime(data1: number, data2: number): Promise<boolean> {
    console.log(data1, data2);

    return new Promise<boolean>((resolve, reject) => {
      if (data1 === data2) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  }


  doctorprofile(profileRef: firebase.firestore.DocumentReference) {
    this.modalController.create({
      component: DoctorProfileTypeModalPage, id: 'DoctorProfileTypeModal', componentProps: {
        profilePath: profileRef.path,
        profileId: profileRef.id
      }
    }).then((modalElement) => {
      modalElement.present();
    }
    );


    // profilin modal hali yapılacak

    /*  this.modalController.dismiss();

        let navigationExtras: NavigationExtras = {
          state: {
              profilePath: profileRef.path,
              profileId: profileRef.id
          }
      };
      this.navCtrl.navigateForward(['doctorprofile'], navigationExtras); */


  }
  // tslint:disable-next-line:max-line-length
  public async connectToDoctor(path: string, accountId: string, proileId: string, expertName: string) { // path = profileRef => accound/id/profile/id



    if (this.conversationType === 'video') {


      const videoConference = {} as VideoConference;
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          this.firestore.collection('accounts').doc(user.uid).get().toPromise().then(account => {
            if (account) {
              const data = account.data() as AccountModel;
              videoConference.createdAt = new Date();
              videoConference.subscriberId = user.uid;
              videoConference.connectionStatus = ConnectionStatus.not_started;
              videoConference.subscriberFullName = data.name;
              videoConference.expertFullName = expertName;
              videoConference.expertPath = path;
              videoConference.expertId = proileId;
              videoConference.expertAccountId = accountId;
              videoConference.status = ConferenceStatus.pending;
              videoConference.payStatus = false;
              videoConference.type = ConferencType.video;
              videoConference.roomName = expertName + '/video-call/room/name/' + this.firestore.createId();
              this.firestore.collection('videoConference').add(Object.assign({}, videoConference)).then(res => {
                this.crudService.showAlertComplete(
                  this.translate.instant('request_header_conversation'),
                  this.translate.instant('request_sended_to_expert_check_your_appointments'),
                  this.translate.instant('okay')
                );
                this.modalController.dismiss(null, null, 'ChooseDoctorList');
                this.modalController.dismiss(null, null, 'ChooseDoctor');
              }).catch(err => {
                console.log(err);
              });

            }
          }).catch(errAccount => {
            console.log(errAccount);
          });
        }
      }).then().catch(err => {
        console.log(err);
      });


    }
    if (this.conversationType === 'voice') {
      const videoConference = {} as VideoConference;
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          this.firestore.collection('accounts').doc(user.uid).get().toPromise().then(account => {
            if (account) {
              const data = account.data() as AccountModel;
              videoConference.createdAt = new Date();
              videoConference.subscriberId = user.uid;
              videoConference.connectionStatus = ConnectionStatus.not_started;
              videoConference.subscriberFullName = data.name;
              videoConference.expertFullName = expertName;
              videoConference.expertPath = path;
              videoConference.expertId = proileId;
              videoConference.expertAccountId = accountId;
              videoConference.status = ConferenceStatus.pending;
              videoConference.payStatus = false;
              videoConference.type = ConferencType.audio;
              videoConference.roomName = expertName + '/audio-call/room/name/' + this.firestore.createId();
              this.firestore.collection('videoConference').add(Object.assign({}, videoConference)).then(res => {
                this.crudService.showAlertComplete(
                  this.translate.instant('request_header_conversation'),
                  this.translate.instant('request_sended_to_expert_check_your_appointments'),
                  this.translate.instant('okay')
                );
                this.modalController.dismiss(null, null, 'ChooseDoctorList');
                this.modalController.dismiss(null, null, 'ChooseDoctor');
              }).catch(err => {
                console.log(err);
              });

            }
          }).catch(errAccount => {
            console.log(errAccount);
          });
        }
      }).then().catch(err => {
        console.log(err);
      });
    }
    if (this.conversationType === 'chat') {
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          this.firestore.collection('accounts').doc(user.uid).get().toPromise().then(async account => {
            if (account) {
              this.modalController.dismiss(null, null, 'ChooseDoctorList');
              this.modalController.dismiss(null, null, 'ChooseDoctor');
              const navigationExtras: NavigationExtras = {
                queryParams: {
                  subscriber: account.id,
                  path,
                  expert: accountId,
                  profileId: proileId
                }
              };
              await this.navCtrl.navigateForward(['./chatscreen'], navigationExtras);
            }
          }).catch(err => {
            console.log(err);
          });
        }
      });

    }

  }

  getPayment(path: string, accountId: string, proileId: string, expertName: string, price: number) {
    const convInfo = {} as ConvInfo;
    convInfo.accountId = accountId;
    convInfo.path = path;
    convInfo.proileId = proileId;
    convInfo.expertName = expertName;
    convInfo.conversationType = this.conversationType;
    this.convService.setConversation(convInfo);
    this.modalController.create({
      component: CheckoutIyzicoPage, id: 'IyzıcoCheckoutModal', componentProps: {
        path,
        accountId,
        proileId,
        expertName,
        price
      }
    }).then((modalElement) => {
      modalElement.present();
    }
    );

  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }

}
